export const useOpenModalAfterTime = () => {
  const DEFAULT_TIME_IN_MS: number = 43200000;
  const MINIMUM_WALLET_BALANCE: number = 99;

  function execute(): void {
    const walletStore = useWalletStore();
    const { userCanOnlyWithdraw } = useUserLimits();
    const { openDepositModalMinBalance } = useRuntimeConfig().public.layout;

    const credit: number = walletStore.realWallet.creditAmount;

    const minimumValue: number = Number(
      openDepositModalMinBalance || MINIMUM_WALLET_BALANCE,
    );

    if (credit > minimumValue) return;

    if (userCanOnlyWithdraw.value) {
      return;
    }

    if (getModalOpenTimeFromLocalStorage()) {
      return checkAndUpdateModalOpenTime();
    }

    openModalAndSetInLocalStorageNextTimeToOpen();
  }

  function clear(): void {
    clearModalOpenDataFromLocalStorage();
  }

  function openModalAndSetInLocalStorageNextTimeToOpen(): void {
    const { openDepositModal } = usePayments();

    openDepositModal();

    window.localStorage.setItem(
      'nextModalOpenTime',
      `${addXHoursToCurrentTimestamp()}`,
    );
  }

  function checkAndUpdateModalOpenTime(): void {
    if (!hasPassed12HoursSinceModalOpen()) return;

    openModalAndSetInLocalStorageNextTimeToOpen();
  }

  function hasPassed12HoursSinceModalOpen(): boolean {
    return getCurrentDatetime() >= Number(getModalOpenTimeFromLocalStorage());
  }

  function getModalOpenTimeFromLocalStorage(): string {
    return window.localStorage.getItem('nextModalOpenTime') as string;
  }

  function addXHoursToCurrentTimestamp(): number {
    return getCurrentDatetime() + hoursInMilliseconds();
  }

  function getCurrentDatetime(): number {
    return new Date().getTime();
  }

  function hoursInMilliseconds(): number {
    const { openDepositModalInterval } = useRuntimeConfig().public.layout;

    return Number(openDepositModalInterval || DEFAULT_TIME_IN_MS);
  }

  function clearModalOpenDataFromLocalStorage(): void {
    window.localStorage.removeItem('nextModalOpenTime');
  }

  return {
    execute,
    clear,
  };
};
